"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApPopoverReference = exports.ApPopoverManager = exports.ApPopover = void 0;
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* tslint:disable */
var React = require("react");
var react_1 = require("react");
/* tslint:enable */
var ReactDOM = require("react-dom");
var react_popper_1 = require("react-popper");
Object.defineProperty(exports, "ApPopoverManager", { enumerable: true, get: function () { return react_popper_1.Manager; } });
Object.defineProperty(exports, "ApPopoverReference", { enumerable: true, get: function () { return react_popper_1.Reference; } });
var classcaded_1 = require("../../utils/classcaded");
var setReactRef_1 = require("../../utils/setReactRef");
var ApOutsideClick_1 = require("../ApOutsideClick/ApOutsideClick");
var styles_1 = require("./styles");
var OutsideClickOrProxy = function (_a) {
    var disableOutsideClick = _a.disableOutsideClick, children = _a.children, rest = __rest(_a, ["disableOutsideClick", "children"]);
    return disableOutsideClick ? (children) : (React.createElement(ApOutsideClick_1.default, __assign({}, rest), children));
};
/**
 * Robust and composable popover.
 *
 * It builds upon [Popper.js](https://popper.js.org) and all of its positioning logic,
 * e.g.:
 *
 * - it never hides behind window boundaries (or boundaries of the parent scroll element)
 * - it repositions itself as the user scrolls
 * - its position always follows the button (popover reference)
 *
 * See the story, https://popper.js.org and https://github.com/FezVrasta/react-popper
 * for documentation and examples of usage.
 */
exports.ApPopover = function (_a) {
    var _b = _a.children, children = _b === void 0 ? null : _b, onClose = _a.onClose, className = _a.className, _c = _a.hideArrow, hideArrow = _c === void 0 ? false : _c, _d = _a.disableOutsideClick, disableOutsideClick = _d === void 0 ? false : _d, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onFocus = _a.onFocus, onBlur = _a.onBlur, modifiers = _a.modifiers, _e = _a.stopPropagation, stopPropagation = _e === void 0 ? true : _e, _f = _a.containerProps, containerProps = _f === void 0 ? {} : _f, rest = __rest(_a, ["children", "onClose", "className", "hideArrow", "disableOutsideClick", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur", "modifiers", "stopPropagation", "containerProps"]);
    var onContentClick = react_1.useCallback(function (event) {
        // By default don't bubble events through portals. This is based on the fact
        // that click handlers on Popover triggers seldom want to react to clicks
        // inside the Popover.
        // This also prevent events from reaching OutsideClick and thus fixing
        // outside click for multiple nested Popovers.
        // More details in https://github.com/facebook/react/issues/11387
        // TODO Revisit
        if (stopPropagation) {
            event.stopPropagation();
            // See comments in OutsideClick
            event.preventDefault();
        }
    }, [stopPropagation]);
    return ReactDOM.createPortal(React.createElement(react_popper_1.Popper, __assign({}, rest, { modifiers: __assign({ 
            // GPU acceleration causes blurry popper content
            // with zoom!=100% on non-retina displays.
            // This is important for CHC as users will often zoom out
            // the app to see more content on the page.
            // https://github.com/FezVrasta/popper.js/issues/3
            // https://bugs.chromium.org/p/chromium/issues/detail?id=573146
            computeStyle: { gpuAcceleration: false } }, modifiers) }), function (childProps) { return (React.createElement(OutsideClickOrProxy, { disableOutsideClick: disableOutsideClick, onClick: onClose, shouldPreventDefault: false, useCapture: false },
        React.createElement(styles_1.PopoverContainer, __assign({}, containerProps, { ref: function (node) {
                setReactRef_1.setReactRef(childProps.ref, node);
                if (containerProps.ref) {
                    setReactRef_1.setReactRef(containerProps.ref, node);
                }
            }, style: __assign(__assign({}, containerProps.style), childProps.style), role: "tooltip", className: classcaded_1.classcaded(containerProps.className, className), hideArrow: hideArrow, "data-placement": childProps.placement, onClick: onContentClick, onMouseEnter: onMouseEnter || containerProps.onMouseEnter, onMouseLeave: onMouseLeave || containerProps.onMouseLeave, onFocus: onFocus || containerProps.onFocus, onBlur: onBlur || containerProps.onBlur }),
            typeof children === 'function' ? children(childProps) : children,
            !hideArrow && (React.createElement(styles_1.Arrow, { ref: childProps.arrowProps.ref, style: childProps.arrowProps.style, "data-placement": childProps.placement, className: "ap-popover-arrow" }))))); }), document.body);
};
//# sourceMappingURL=ApPopover.js.map